import DatePicker from '../../../components/Forms/DatePicker/DatePicker';
import InputField from '../../../components/Forms/Input/InputField';
import { useBasePurchase } from '../../../hooks/purchases/useBasePurchase';

const PurchaseCreditDaysSection = () => {
  const { form, updateField, purchaseSettlementLoaded } = useBasePurchase();

  return (
    <>
      {/* Selección manual de fecha */}
      <DatePicker
        name="paymentCondition.creditDueDate"
        label="Fecha Plazo del Crédito"
        iconKey="calendar"
        value={form.paymentCondition?.creditDueDate || ''}
        onChange={(date) => {
          if (!form.purchaseDate) return;

          const start = new Date(form.purchaseDate);
          const end = new Date(date);
          const diffInDays = Math.ceil(
            (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24)
          );

          updateField('paymentCondition', {
            ...form.paymentCondition,
            creditDueDate: date,
            creditDays: diffInDays >= 0 ? diffInDays : 0,
          });
        }}
        disabled={purchaseSettlementLoaded}
      />

      {/* Campo para escribir manualmente los días */}
      <InputField
        name="paymentCondition.creditDays"
        label="Días Plazo del Crédito"
        iconKey="calendar"
        type="number"
        min={0}
        placeholder="Días plazo del crédito"
        value={
          form.paymentCondition?.creditDays !== undefined &&
          form.paymentCondition?.creditDays !== null
            ? form.paymentCondition.creditDays
            : ''
        }
        onChange={(e) => {
          const value = e.target.value.trim();

          if (value === '') {
            updateField('paymentCondition', {
              ...form.paymentCondition,
              creditDays: undefined,
              creditDueDate: '',
            });
            return;
          }

          const days = Number(value);
          if (form.purchaseDate && !isNaN(days)) {
            const start = new Date(form.purchaseDate);
            const dueDate = new Date(start);
            dueDate.setDate(start.getDate() + days);

            updateField('paymentCondition', {
              ...form.paymentCondition,
              creditDays: days,
              creditDueDate: dueDate.toISOString().split('T')[0],
            });
          }
        }}
        disabled={purchaseSettlementLoaded}
      />
    </>
  );
};

export default PurchaseCreditDaysSection;
